$(document).on('click', '.js-tab-divider', function() {
    $(this).closest('.nav').find(' .divider').removeClass('hide');
    $(this).closest(' .nav-item').next().addClass('hide');
    $(this).closest(' .nav-item').prev().addClass('hide');
});

$(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
    const tabUrl = $(e.target).data('route');
    if(tabUrl) {
        window.history.pushState({}, '', tabUrl);
    }
})
/**
 * @TODO Change code for multiple blocks
 * @type {*|jQuery|HTMLElement}
 */
const jsDishRecommendationsBlock = $('.js-dish-recommendations-list')
if(jsDishRecommendationsBlock.length && jsDishRecommendationsBlock.data('route')) {
    const currentRecommendations = JSON.parse(jsDishRecommendationsBlock.find('[name="recommendationsIds"], [name^="hiddenDishIds"]').val()),
        currentRecommendationsSort = JSON.parse(jsDishRecommendationsBlock.find('[name="recommendationsIdsSort"]').val()),
        recommendationsItemsBlock = jsDishRecommendationsBlock.find('.js-dish-recommendations-list-items'),
        currentId = +jsDishRecommendationsBlock.data('id'),
        lang = jsDishRecommendationsBlock.data('lang'),
        langSort = jsDishRecommendationsBlock.data('lang-sort'),
        addText = jsDishRecommendationsBlock.data('text-add'),
        removeText = jsDishRecommendationsBlock.data('text-remove')

    $(document).on('click', '.js-dish-recommendations-list-search', function() {
        getRecommendations({
            search: $('.js-dish-recommendations-list-search-field').val(),
            category: $('.js-dish-recommendations-list-search-category').val(),
            lang,
            langSort,
            currentRecommendationsSort
        })
    })


    const getRecommendations = (data, firstRun) => {
        data = data || {}
        firstRun = firstRun || false
        $.get(jsDishRecommendationsBlock.data('route'), data, function(items) {

            if(!firstRun) {
                recommendationsItemsBlock.find('.list-group-item').addClass('d-none')
            }

            const sortedItems = Object.entries(items).sort(([aItemId,a],[bItemsId,b]) => {
                return  +aItemId in currentRecommendations ? -1 : 1;
            })

            for(const [itemId, item] of sortedItems) {
                if(+itemId === currentId) {
                    continue;
                }
                if(!firstRun) {
                    recommendationsItemsBlock.find('.list-group-item[data-id="' + itemId + '"]').removeClass('d-none')
                    continue ;
                }

                const isChecked = itemId in currentRecommendations;
                item['sort'] = +(currentRecommendationsSort[itemId] || 0)
                let itemImgPath = '';
                if(item['item_preview_image'] && /\.(?:jpe?g|png|gif|bpm)$/i.test(item['item_preview_image'])) {
                    itemImgPath = `/storage/${item['item_preview_image']}`
                } else if(item['image'] && /\.(?:jpe?g|png|gif|bpm)$/i.test(item['image'])) {
                    itemImgPath = `/storage/${item['image']}`
                }
                const itemImg = `<img class="img-thumbnail" src="${itemImgPath}" onerror="this.src='/build/images/coming_soon.jpg';this.onerror=''" style="max-width: 100px" alt="${item['name']}">`

                recommendationsItemsBlock.append(
                    `<li data-id="${item.id}" class="list-group-item list-group-item-action pl-2">
                        <div class="row row-cols-1 row-cols-sm-2 row-cols-xl-5 align-items-center">
                            <div class="col my-1">
                                <div class="align-items-center row row-cols-1 row-cols-md-2">
                                    <div class="col">
                                        <b>${item.unique_id ? '#' + item.unique_id : ' - '}</b>
                                    </div>
                                    <div class="col">
                                        ${itemImg}
                                    </div>
                                </div>
                            </div>
                            <div class="col my-1 font-weight-bold">
                                ${item['name']}
                            </div>
                            <div class="col my-1 font-weight-bold" title="${item['category_full']}" style="cursor: help">
                                ${item['category']}
                            </div>
                            <div class="col my-1 font-weight-bold">
                                ${item['grape_variety']}
                            </div>
                            <div class="col my-1">
                                <input type="number" name="sort" class="form-control js-recom-sort" title="${langSort}" value="${item['sort']}" style="max-width: 90px">
                                <small class="form-text mt-0 text-muted" style="margin-left:10px">${langSort}</small>
                                <label class="form-check-inline mr-0 js-dish-recommendations-list-checkbox" style="cursor: pointer;">
                                    <input type="checkbox" ${isChecked ? ' checked' : ''} class="form-check-inline js-recom-checkbox mr-1 mr-md-2" value="${item.id}">
                                    <span class="js-recom-checkbox-text">${isChecked ? removeText : addText}</span>
                                </label>
                            </div>
                        </div>
                    </li>`
                );
            }
        }, 'json')
    }
    getRecommendations({ lang, langSort, currentRecommendationsSort }, true)

    $(document).on('change input', '.js-recom-checkbox', function() {
        jsDishRecommendationsBlock.find('[name="recommendationsIds"], [name^="hiddenDishIds"]').val(JSON.stringify(Object.fromEntries(Array.from(
                document.querySelectorAll('.js-recom-checkbox:checked')
            ).map((item) => [item.value, null]).sort())
        ))
        $(this).closest('.col').find('.js-recom-sort').trigger('change')
        document.querySelectorAll('.js-recom-checkbox').forEach((item) => {
            item.nextElementSibling.innerText = item.checked ? removeText : addText
        })
    })
    $(document).on('change input', '.js-recom-sort', function() {
        let sorts = {};
        document.querySelectorAll('.js-recom-checkbox:checked').forEach((chck) => {
            sorts[chck.value] = chck.closest('.col').querySelector('.js-recom-sort').value
        })
        jsDishRecommendationsBlock.find('[name="recommendationsIdsSort"]').val(JSON.stringify(sorts))
    })
}
